<template>
    <div class="container">
      <div class="content-i">
        <div class="content-box">
            <div class="row justify-content-center">
              <div class="col">
                <div class="element-wrapper">
                  <h6 class="element-header">
                    Defina Seus dados de acesso
                  </h6>
                  <div class="element-box">
                    <div class="col-md-6 offset-md-3">
                      <form @submit.prevent="salvar">
                        <h5 class="form-head">
                            Defina os dados de acesso.
                        </h5>
                        <div class="form-desc">
                            Lembre-se seus dados de acesso é de uso pessoal e instransferível.
                        </div>
                        <div class="form-row">
                          <div class="form-group col">
                            <label for="username">Nome</label>
                              <input type="text" name="name" id="name"
                                v-model="payload.name" required
                                class="form-control">
                          </div>
                        </div>
                        <div class="form-row">
                          <div class="form-group col-md-6">
                            <label for="username">CPF</label>
                              <input type="text" name="cpf" id="cpf"
                                v-mask="'###.###.###-##'"
                                v-model="payload.cpf" required
                                class="form-control">
                          </div>
                        </div>
                        <div class="form-row">
                          <div class="form-group col-md-6">
                            <div class="form-group">
                              <label for="email">Email</label>
                              <input type="email" name="email" id="email"
                                v-model="payload.email" required
                                class="form-control" aria-describedby="helpId">
                            </div>
                          </div>
                          <div class="form-group col-md-6">
                            <div class="form-group">
                              <label for="celular">Celular</label>
                              <input type="tel" name="celular" id="celular"
                                v-model="payload.telefoneCelular" required
                                v-mask="['(##) ####-####', '(##) #####-####']"
                                class="form-control" aria-describedby="helpId">
                            </div>
                          </div>
                        </div>
                        <div class="form-row">
                          <div class="form-group col">
                            <label for="username">Usuario</label>
                              <input ref="username" type="text" name="username" id="username"
                                v-model="payload.username" required
                                class="form-control">
                          </div>
                        </div>
                        <div class="form-row">
                          <div class="form-group col">
                            <label for="senha">Senha</label>
                              <input type="password" name="senha" id="senha"
                                v-model="payload.password" required
                                class="form-control" aria-describedby="helpId">
                          </div>
                        </div>
                        <div class="form-row">
                          <div class="form-group col">
                            <label for="repeteSenha">Repetir Senha</label>
                              <input type="password" name="repeteSenha" id="repeteSenha"
                                v-model="repeteSenha" required
                                class="form-control" aria-describedby="helpId">
                          </div>
                        </div>

                        <div class="form-buttons-w">
                            <button v-if="!cartaoCompra" type="button" class="btn btn-secondary" @click="goPergunta">Voltar</button>
                            <button type="submit" class="btn btn-primary">Salvar</button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </div>
    </div>
    </div>
</template>
<script>
export default {
  computed: {
    cartaoCompra () {
      return window.localStorage.getItem('cartaoCompra')
    }
  },
  mounted () {
    if (this.cartaoCompra) {
      let cartaoCompra = JSON.parse(this.cartaoCompra)
      this.payload.name = cartaoCompra.name
      this.payload.email = cartaoCompra.email
      this.payload.cpf = cartaoCompra.cpf
      this.payload.telefoneCelular = cartaoCompra.telefoneCelular
      this.$nextTick(() => this.$refs.username.focus())
    }
  },
  data () {
    return {
      repeteSenha: null,
      payload: {
        email: null,
        telefoneCelular: null,
        username: null,
        password: null
      }
    }
  },
  methods: {
    goPergunta () {
      this.$router.push({name: 'Cadastrese-pergunta'})
    },
    clear () {
      this.payload = {
        name: null,
        cpf: null,
        email: null,
        telefoneCelular: null,
        username: null,
        password: null
      }
      this.repeteSenha = null
    },
    salvar () {
      if (this.repeteSenha === this.payload.password) {
        this.payload.role = 'DRACHEI'
        this.$store.dispatch('saveUserDrAchei', this.payload)
          .then((usr) => {
            this.clear()
            this.$store.dispatch('setNomeUsuario', usr.name)
            this.$router.push({name: 'Cadastrese-sucesso'})
          })
      } else {
        this.$toasted.show('As senhas não correspondem', {
          icon: { name: 'fa-exclamation-triangle' },
          type: 'error',
          theme: 'bubble',
          action: {
            text: 'FECHAR',
            onClick: (e, toastObject) => {
              toastObject.goAway(0)
            }
          }
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/cadastrese/UsuarioDrachei.vue